module.exports = __webpack_public_path__ + "img/42.b6c2167a.jpg";